

import { Component} from '@angular/core';
import { HttpClient} from '@angular/common/http'; 
import { AuthService } from '../../../_services/index'; 
import { LoaderService } from 'app/_services/loader.service';
import { environment } from '.../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import * as _moment from 'moment';  
import * as _rollupMoment from 'moment'; 
const moment = _rollupMoment || _moment;  
import { Router } from '@angular/router';
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver';
declare var $: any; 

@Component({
    selector: 'logbook-TS',
    templateUrl: './tsLogbook.component.html' 
   
  })
 
  export class TSLogbookComponent{ 
    public prjId:any;
    showLoader:any;
    startDate:any;
    endDate:any;
    defStartDt:any;
    defEndDt:any;
    dataRangeModal:any;
    logBookList:any;
    tsLogbookRequired=false;
    tsLogbookDetailsRequired=false;
    tsMaintenanceDetailsList:any;
    totalAmount:any;
    MaintenanceDays:any;
    tsMaintenanceCount:any;
    tsMaintenanceSearch:any;
    selectedRow:number;
    constructor(private auth : AuthService,private http : HttpClient ,private loaderService: LoaderService,public router: Router) {
    this.loaderService.status.subscribe((val: boolean) =>{
      this.showLoader = val;
    });  
    var date = new Date(); 
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1); 
    this.defStartDt = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate(); 
    this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dataRangeModal= {beginDate: {year: firstDay.getFullYear(), month: firstDay.getMonth()+1, day: firstDay.getDate()}, endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}};
    }  
   

    /*
     * GET TS LOG BOOK LIST
    */
    getTSLogbookList(startDate,endDate){
        this.loaderService.display(true); 
        this.http.get(environment.apiUrl + 'maintenance/getTSlogbook?prjId='+this.prjId+'&fromDate='+startDate+'&toDate='+endDate).subscribe(data =>{
            this.logBookList=data; 
            if(this.logBookList.length==0) {
                this.tsLogbookRequired=true;
            }else{
                this.tsLogbookRequired=false; 
            }
            this.loaderService.display(false); 
        });
    }


        
    /*
    * select start Date Nad To date
    */
    onDateRangeChanged(dataRange){  
    if(dataRange.beginDate.day>0){ 
        this.startDate= dataRange.beginDate.year + "-"  + dataRange.beginDate.month+ "-" + dataRange.beginDate.day 
        this.endDate = dataRange.endDate.year + "-"  + dataRange.endDate.month  + "-" + dataRange.endDate.day 
        this.getTSLogbookList(this.startDate,this.endDate);
    }else if(dataRange.beginDate.day==0){
        this.startDate= this.defStartDt
        this.endDate = this.defEndDt
        this.getTSLogbookList(this.startDate,this.endDate);
      }  
    } 

    /*
    *  Get TS info Modal popup windows
    */ 
    getTSDetails(data){
    var tsId=data.TSID
    console.log("tsId",tsId)
    this.getTsDetails(tsId)
    $('#tsDetailsModal').modal('show'); 
    }


    /*
     *  GET TS MAINTENANCE DETAILS
    */  
    getTsDetails(tsId){
        this.http.get(environment.apiUrl + 'maintenance/getTsMaintenanceDetail?tsId='+tsId).subscribe(data =>{
            this.tsMaintenanceDetailsList=data;
            this.tsMaintenanceCount= this.tsMaintenanceDetailsList.length
            console.log("data",this.tsMaintenanceDetailsList) 
            if(this.tsMaintenanceDetailsList.length==0) {
                this.tsLogbookDetailsRequired=true;
            }else{
              this.totalAmount=0;
              for(var i=0; i<this.tsMaintenanceDetailsList.length;i++){
                this.totalAmount=this.totalAmount+Number(this.tsMaintenanceDetailsList[i].TotalAmount)
                this.MaintenanceDays=this.MaintenanceDays+this.tsMaintenanceDetailsList[i].MaintenanceDays
              }
                this.tsLogbookDetailsRequired=false; 
            }
            this.loaderService.display(false); 
        });
    }

    /*
     *  GET TS MAINTENANCE INFO DETAILS
    */ 
    getTSInfo(data){
        console.log("data",data) 
        this.getTsDetails(data.TSID) 
        $('#tsInfoModal').modal('show');
      }


      
 /*
  *Down Load Excel file 
  */
 downloadExcelFile(data){
    const ws_name = 'TSMaintenanceReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'TsReport.xlsx');
    }
    s2ab(s) 
    {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
      };
      return buf;
    }


    selectRowIndex(index){
      this.selectedRow=index;
    }

    



  
    ngOnInit(){
      this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
      this.endDate= moment(this.defEndDt).format('YYYY-MM-DD');
      this.prjId = this.auth.getAuthentication().projectId 
      this.getTSLogbookList(this.startDate, this.endDate);
    }
  }


// WEBPACK FOOTER //
// ./src/app/maintenance/TS/tsMaster/tsLogbook.component.ts